export default __webpack_public_path__ + "static/media/cloud-computing.f79e9b26.svg";